import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Services", to: "/services" },
  { label: "Process", hash: "#process" },
  { label: "About", to: "/about" },
  { label: "Contact", hash: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handle = (l) => {
    setOpen(false);
    if (l.to) {
      navigate(l.to);
      window.scrollTo({ top: 0 });
      return;
    }
    if (location.pathname !== "/") {
      navigate("/" + l.hash);
      return;
    }
    const el = document.querySelector(l.hash);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 bg-white transition-shadow duration-300 ${
        scrolled ? "border-b border-[#E5E5E5]" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[88px] flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => {
            navigate("/");
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex flex-col items-start leading-none"
        >
          <img src="/pikosky-logo.png" alt="Pikosky Partners" className="h-11 w-auto" />
          <span className="font-premium italic text-[0.95rem] text-[#14213D] mt-1.5 tracking-wide">
            Accounting for your success
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-${l.label.toLowerCase()}`}
              onClick={() => handle(l)}
              className="label-tech !text-[#0A0A0A] hover:!text-[#3B37E5] transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-[#0A0A0A]"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E5E5E5] bg-white">
          <div className="px-6 py-5 flex flex-col gap-4">
            {links.map((l) => (
              <button
                key={l.label}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                onClick={() => handle(l)}
                className="font-display text-2xl text-left text-[#0A0A0A]"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
